<template>
  <ParagraphBody
    data-test-id="ResourceError__errorText"
  >
    <Icon
      :class="$style.errorIcon"
      icon="error"
      inline
    />
    {{ $options.errorText }}
  </ParagraphBody>
</template>

<script>
import { Icon, ParagraphBody } from '@jumpcloud/ui-components';

export default {
  name: 'ResourceError',

  components: {
    Icon,
    ParagraphBody,
  },

  errorText: 'Sorry, we are unable to gather results for this category. Try refreshing your browser to resolve.',
};
</script>

<style module scoped>
.errorIcon {
  color: var(--jc-color-error-strong);
}
</style>
